/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A period-over-period change in a metric, used to show movement (for example a rise in impacts per activity hour versus the prior window). Renders as a coloured delta badge in the UI.
 */
export interface Delta { 
    /**
     * Magnitude of the change. Interpreted according to `unit` (for example 15.1 with unit \'percent\' means a 15.1% change; 54 with unit \'count\' means 54 more events).
     */
    value: number;
    /**
     * Unit the `value` is expressed in. Typically \'percent\' for rate changes or \'count\' for absolute changes in a number of events, sites, or operators.
     */
    unit?: string;
    /**
     * Whether the metric moved up or down versus the comparison period. This is the raw arithmetic direction and is independent of whether the movement is good or bad (see `sentiment`).
     */
    direction: Delta.DirectionEnum;
    /**
     * Whether the change is good (\'positive\') or bad (\'negative\') for safety. A rising impact rate is \'negative\'; a falling impact rate is \'positive\'. Drives the badge colour independently of `direction`.
     */
    sentiment: Delta.SentimentEnum;
    /**
     * Human-readable label for the baseline the change is measured against, for example \'prior 30 days\' or \'enterprise average\'.
     */
    comparison?: string | null;
}
export namespace Delta {
    export const DirectionEnum = {
        Up: 'up',
        Down: 'down'
    } as const;
    export type DirectionEnum = typeof DirectionEnum[keyof typeof DirectionEnum];
    export const SentimentEnum = {
        Positive: 'positive',
        Negative: 'negative'
    } as const;
    export type SentimentEnum = typeof SentimentEnum[keyof typeof SentimentEnum];
}


